import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useId } from '@reach/auto-id';
import { useControlledComponent } from "../../hooks";
import { useState } from 'react';
export function useCollapse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isShowingProp = _ref.isShowing,
      onRequestChange = _ref.onRequestChange,
      defaultShowing = _ref.defaultShowing,
      _ref$monitorHeight = _ref.monitorHeight,
      monitorHeight = _ref$monitorHeight === void 0 ? false : _ref$monitorHeight,
      id = _ref.id,
      disabled = _ref.disabled;

  var uid = useId(id);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      intentToAnimate = _useState2[0],
      setIntentToAnimate = _useState2[1];

  var _useControlledCompone = useControlledComponent(isShowingProp, onRequestChange, defaultShowing),
      _useControlledCompone2 = _slicedToArray(_useControlledCompone, 2),
      isShowing = _useControlledCompone2[0],
      setIsShowing = _useControlledCompone2[1];

  var triggerId = "".concat(uid, "-trigger");
  var triggerEventHandlers = !disabled && {
    onMouseEnter: function onMouseEnter() {
      return setIntentToAnimate(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIntentToAnimate(false);
    },
    onClick: isShowingProp != null && !onRequestChange ? undefined : function () {
      return setIsShowing(!isShowing);
    }
  };
  return {
    isShowing: isShowing,
    id: uid,
    monitorHeight: monitorHeight,
    intentToAnimate: intentToAnimate,
    bindTrigger: _objectSpread({
      type: 'button',
      id: triggerId,
      'aria-controls': uid,
      'aria-expanded': isShowing,
      'aria-disabled': disabled
    }, triggerEventHandlers),
    bindCollapse: {
      id: uid,
      'aria-labelledby': triggerId,
      role: 'region'
    }
  };
}